document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mt-producto').forEach(initGaleria);
  document.querySelectorAll('[data-mt-form]').forEach(initVariantes);
});

function initGaleria(seccion) {
  var imagenPrincipal = seccion.querySelector('[id^="mt-imagen-principal-"]');
  var miniaturas = seccion.querySelectorAll('[data-mt-miniatura]');
  if (!imagenPrincipal || !miniaturas.length) return;

  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nuevaSrc = btn.getAttribute('data-imagen-grande');
      if (!nuevaSrc) return;
      imagenPrincipal.src = nuevaSrc;
      miniaturas.forEach(function (m) { m.style.borderColor = 'var(--mt-color-panel-borde)'; });
      btn.style.borderColor = 'var(--mt-color-acento)';
    });
  });
}

function initVariantes(form) {
  var seccion = form.closest('[id^="shopify-section-"]');
  if (!seccion) return;
  var scriptId = seccion.id.replace('shopify-section-', '');
  var variantesScript = seccion.querySelector('[data-mt-variantes-' + scriptId + ']');
  if (!variantesScript) return;

  var variantes;
  try {
    variantes = JSON.parse(variantesScript.textContent);
  } catch (e) {
    return;
  }

  var grupos = form.querySelectorAll('[data-mt-opcion]');
  var inputId = form.querySelector('[id^="mt-variant-id-"]');
  var precioEl = seccion.querySelector('[id^="mt-precio-"]:not([id*="anterior"])');
  var precioAnteriorEl = seccion.querySelector('[id^="mt-precio-anterior-"]');
  var botonComprar = seccion.querySelector('[id^="mt-boton-comprar-"]');
  var textoAgotado = form.dataset.textoAgotado;

  function seleccionActual() {
    var seleccion = [];
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-opcion-valor--activa');
      seleccion.push(activo ? activo.getAttribute('data-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante(seleccion) {
    return variantes.find(function (v) {
      return seleccion.every(function (valor, i) {
        return valor === null || v.options[i] === valor;
      });
    });
  }

  function actualizar() {
    var seleccion = seleccionActual();
    var variante = encontrarVariante(seleccion);
    if (!variante) return;

    if (inputId) inputId.value = variante.id;

    if (precioEl) {
      precioEl.textContent = formatoDinero(variante.price);
    }
    if (precioAnteriorEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnteriorEl.textContent = formatoDinero(variante.compare_at_price);
        precioAnteriorEl.style.display = '';
      } else {
        precioAnteriorEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      botonComprar.textContent = variante.available
        ? botonComprar.getAttribute('data-texto-disponible') || botonComprar.textContent
        : (textoAgotado || 'Agotado');
    }
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('.mt-opcion-valor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('.mt-opcion-valor').forEach(function (b) { b.classList.remove('mt-opcion-valor--activa'); });
        btn.classList.add('mt-opcion-valor--activa');
        actualizar();
      });
    });
  });

  if (botonComprar && !botonComprar.hasAttribute('data-texto-disponible')) {
    botonComprar.setAttribute('data-texto-disponible', botonComprar.textContent.trim());
  }
}

function formatoDinero(centavos) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme_money_format) {
    return window.Shopify.formatMoney(centavos, window.theme_money_format);
  }
  return '€' + (centavos / 100).toFixed(2).replace('.', ',');
}
